import React from 'react';

const OrganizationDashboardIcon = ({ fill = 'currentColor', className = '' }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <mask
      id="mask0_1398_4123"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="28"
      height="28"
    >
      <rect width="28" height="28" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1398_4123)">
      <path
        d="M3.5 12.8333V3.5H12.8333V12.8333H3.5ZM3.5 24.5V15.1667H12.8333V24.5H3.5ZM15.1667 12.8333V3.5H24.5V12.8333H15.1667ZM15.1667 24.5V15.1667H24.5V24.5H15.1667ZM5.83333 10.5H10.5V5.83333H5.83333V10.5ZM17.5 10.5H22.1667V5.83333H17.5V10.5ZM17.5 22.1667H22.1667V17.5H17.5V22.1667ZM5.83333 22.1667H10.5V17.5H5.83333V22.1667Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default OrganizationDashboardIcon;
